import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tabs, Tab, Alert } from "react-bootstrap";

import axiosClient from "../../api/axiosClient";

// Components
import NavbarAdmin from "../../components/NavbarAdmin";
import UserInfoTab from "../../components/userDetails/tabs/UserInfoTab";
import APISettingsTab from "../../components/userDetails/tabs/APISettingsTab";
import ManualReportsTab from "../../components/userDetails/tabs/ManualReportsTab";
import SettingsTab from "../../components/userDetails/tabs/SettingsTab";

const UserDetails = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("info");
  const [error, setError] = useState("");

  useEffect(() => {
    fetchUser();
  }, [id]);

  const fetchUser = async () => {
    try {
      const res = await axiosClient.get(`/users/${id}`);
      setUser(res.data);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to fetch user");
    }
  };

  if (!user) return <div>Loading...</div>;

  return (
    <div>
      {/* Navbar */}
      <NavbarAdmin />

      <div className="container mt-4">
        {error && <Alert variant="danger">{error}</Alert>}

        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="mb-3"
        >
          <Tab eventKey="info" title="User Information">
            <UserInfoTab user={user} refreshUser={fetchUser} />
          </Tab>

          <Tab eventKey="api" title="API Service Settings">
            <APISettingsTab userId={user.id}  refreshUser={fetchUser} />
          </Tab>

          <Tab eventKey="reports" title="Upload Manual Reports">
            <ManualReportsTab userId={user.id} />
          </Tab>

          <Tab eventKey="settings" title="Settings">
            <SettingsTab userId={user.id} />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default UserDetails;
